module.exports = __webpack_public_path__ + "media/images/application/template/logos/jcb-cb03fbced6679d1f982a35e8c1dc7067.png";